module.exports = "/_next/static/images/f1d1fb829dec611f2586374ec5c41ece-belinda-hero-mobile.jpg.webp";